import { render, staticRenderFns } from "./attrSpecList.vue?vue&type=template&id=38f41818&scoped=true"
import script from "./attrSpecList.vue?vue&type=script&lang=js"
export * from "./attrSpecList.vue?vue&type=script&lang=js"
import style0 from "./attrSpecList.vue?vue&type=style&index=0&id=38f41818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f41818",
  null
  
)

export default component.exports